export const ASSIGN_ROOM_MESSAGE_TEXT = {
    id: 'oe.assignRoom.assignRoomMessageText',
    description: 'Info Message',
    defaultMessage: `Assign Rooms will find all Meetings without a Room and assign them to a matching Room, if one exists.
      A Room matches a meeting if the Meeting Presenter Organization(s) match the Room Presenter(s), and the Meeting start
       and end times both fall within the start and end times of the Room.`
};

export const ASSIGN_ROOM_LABEL_TEXT = {
    id: 'oe.assignRoom.assignRoomTitle',
    description: 'Label text',
    defaultMessage: 'Assign Rooms'
};

export const ASSIGN_V1_MEETINGS_TO_V1_ROOMS = {
    defaultMessage: 'Assign V1 Meetings to V1 Rooms',
    description: 'Label text',
    id: 'oe.assignRoom.assignV1MeetingToV1Rooms',
};

export const ASSIGN_V2_MEETINGS_TO_V2_ROOMS = {
    defaultMessage: 'Assign V2 Meetings to V2 Rooms',
    description: 'Label text',
    id: 'oe.assignRoom.assignV2MeetingToV2Rooms',
};
